import apiClient from './apiClient';

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function getErrorMessage(error) {
  const apiMessage = error.response?.data?.message;
  if (Array.isArray(apiMessage)) return apiMessage[0];
  return apiMessage || error.message || null;
}

export const usdtService = {
  getConfig: () => apiClient.get('/wallet/usdt/config').then((res) => res.data),
  getBalance: () => apiClient.get('/wallet/usdt/balance').then((res) => res.data),
  getDeposits: () => apiClient.get('/wallet/usdt/deposits').then((res) => res.data),
  getWithdrawals: () =>
    apiClient.get('/wallet/usdt/withdrawals').then((res) => res.data),
  confirmDeposit: (txHash, amount) =>
    apiClient
      .post('/wallet/usdt/deposit', { txHash, amount })
      .then((res) => res.data),
  /** Retry while backend waits for more block confirmations. */
  confirmDepositWithRetry: (txHash, amount, { maxAttempts = 20, delayMs = 3000 } = {}) => {
    const attempt = (remaining) =>
      usdtService.confirmDeposit(txHash, amount).catch((error) => {
        const message = String(getErrorMessage(error) || '');
        const waitingConfirmations = /confirmation|รอ/i.test(message);
        if (!waitingConfirmations || remaining <= 1) {
          throw error;
        }
        return sleep(delayMs).then(() => attempt(remaining - 1));
      });

    return attempt(maxAttempts);
  },
  withdraw: (amount) =>
    apiClient.post('/wallet/usdt/withdraw', { amount }).then((res) => res.data),
  getErrorMessage,
};
